import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const setField = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to StayLuxe!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid grid-cols-1 md:grid-cols-2 gap-0" data-testid="register-page">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1661660856169-048271f3d1b3?w=1600&q=80" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 scrim-bottom" />
        <div className="absolute bottom-10 left-10 text-white max-w-xs">
          <p className="font-serif-display text-3xl leading-tight">Join a small, warm community of travellers.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-5">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[hsl(10_51%_55%)]">Create account</p>
            <h1 className="font-serif-display text-3xl mt-2">Join NewDayStays</h1>
          </div>
          <div>
            <Label htmlFor="name">Full name</Label>
            <Input id="name" value={form.name} onChange={setField("name")} required data-testid="register-name" className="mt-2" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={form.email} onChange={setField("email")} required data-testid="register-email" className="mt-2" />
          </div>
          <div>
            <Label htmlFor="phone">Phone (optional)</Label>
            <Input id="phone" value={form.phone} onChange={setField("phone")} data-testid="register-phone" className="mt-2" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={form.password} onChange={setField("password")} required minLength={6} data-testid="register-password" className="mt-2" />
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-forest rounded-full h-11" data-testid="register-submit">
            {loading ? "Creating…" : "Create account"}
          </Button>
          <p className="text-sm text-center text-[hsl(100_3%_30%)]">
            Already a member? <Link to="/login" className="text-[hsl(10_51%_55%)] font-medium" data-testid="link-to-login">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
